import { useCallback, useMemo } from 'react'
import { SWRResponse } from 'swr'
import { Empty } from 'google-protobuf/google/protobuf/empty_pb'
import {
  GetTrustAccountForParentRequest,
  ListOriginsResponse,
} from '@trustero/trustero-api-web/lib/trust/trust_pb'
import { TrustServicePromiseClient } from '@trustero/trustero-api-web/lib/trust/trust_grpc_web_pb'
import { useSwrImmutableGrpc } from 'src/components/async/useSwrImmutableGrpc'
import { GatekeeperFlag, IsGatekeeperEnabled } from 'src/context/Gatekeeper'
import { useAuth } from 'src/context/authContext'
import { useAuthorizedGrpcClient } from 'src/adapter/grpcClient'

export const useTrustPortalAccountId = (): string => {
  const isTrustPortalEnabled = IsGatekeeperEnabled(GatekeeperFlag.TRUST_PORTAL)
  const { accountId } = useAuth()

  const request = useMemo(() => {
    const grpcRequest = new GetTrustAccountForParentRequest()
    grpcRequest.setParentAccountId(accountId)
    return grpcRequest
  }, [accountId])

  const { response } = useSwrImmutableGrpc(
    TrustServicePromiseClient.prototype.getTrustAccountForParent,
    request,
    isTrustPortalEnabled,
  )

  return response?.data?.getAccountId() ?? ''
}

export const useListTrustPortalOrigins =
  (): SWRResponse<ListOriginsResponse> => {
    const { response } = useSwrImmutableGrpc(
      TrustServicePromiseClient.prototype.listOrigins,
      new Empty(),
      true,
    )

    return response
  }

export const useFetchAdminExchangeToken = (): (() => Promise<string>) => {
  const client = useAuthorizedGrpcClient(TrustServicePromiseClient)

  return useCallback(async (): Promise<string> => {
    const response = await client.adminExchangeToken(new Empty())
    return response.getExchangeToken()
  }, [client])
}
